/* eslint-disable max-len */
export default {
  // COMMON
  notUse: '사용 안함',
  use: '사용함',
  dashboard: '대시보드',
  profile: '회원정보',
  administratorsSettings: '관리자 설정',
  mfaSetting: 'MFA 설정',
  registrationManagement: '등록정보 관리',
  outgoingPhone: '발신번호 관리',
  kakaoProfile: '카카오 프로필 관리',
  rejectPhone: '수신거부 번호 관리',
  unsubscribeCustomer: '수신거부 고객 관리',
  departmentInformation: '부서정보 관리',
  userMenu: '사용자 메뉴',
  charge: '청구요금',
  messageUsage: '메시지 사용현황',
  recipientNumber: '수신자 번호 검색',
  activitySearch: 'Activity 검색',
  kakaoTemplate: '알림톡 템플릿 관리',
  images: '이미지 관리',
  solutionGuide: '솔루션 가이드',
  langSelect: '언어 선택',
  messageType: '메시지 타입',
  companyName: '회사명 : 아이투맥스',
  companyCeo: '대표 : 최용훈',
  companyBusinessNumber: '사업자번호 : 120-86-47303',
  companyAddr: '본사 주소 : 04143, 서울시 마포구 마포대로 137 KPX빌딩',
  companyNumber: '대표전화 : 02-365-2187',
  companyFax: '팩스 : 02-365-2093',
  terms: '회원 이용약관',
  privacy: '개인정보 수집 및 이용 동의',
  noList: '리스트 없음',
  noListMsg: '현재 조회 가능한 리스트가 없습니다.',
  total: '총',
  count: '건',
  suffixCount: '건',
  list: '목록',
  unit: '개',
  confirmBtn: '확인',
  deleteBtn: '삭제',
  clostBtn: '닫기 버튼',
  clearBtn: '해제',
  applyState: '적용상태',
  applyYes: '적용',
  applyNo: '미적용',
  regsiterBtn: '등록',
  selected: '선택해주세요.',
  entered: '입력해주세요.',
  journeyNameSearchEntered: '그룹명 또는 ID를 입력해주세요.',
  messageActivitySearchEntered: 'Activity 이름 또는 ID를 입력해주세요.',
  calendarIcon: '달력 아이콘',
  searchBtn: '검색',
  searchToday: '오늘',
  searchWeek: '일주일',
  searchMonth: '1개월',
  searchMonth3: '3개월',
  searchYear: '1년',
  languageSelect: '언어선택',
  korean: '한국어',
  english: '영어',
  downloadOfSearchResults: '검색 결과 다운로드',
  currentConditions: '현재 조건의 검색 결과를 다운로드 하시겠습니까?',
  resettingPassword: '비밀번호 재설정',
  won: '원',
  tail: '더보기',
  administrators: '관리자 목록',
  globalError: '오류가 발생하였습니다.\n관리자에게 문의 부탁드립니다.\ni2message_support@i2max.co.kr',
  mainTitle: 'i2Message Partner Web',
  subTitle: 'Messaging Agent',
  journeyExcelTitle: '메시지 사용현황 > journey',
  activityExcelTitle: '메시지 사용현황 > journey > activity',
  logout: '로그아웃',
  prefixCount: '',
  advert: '(광고)',
  advertFooter: '수신거부 : 홈 > 친구차단',
  reset: '초기화',
  progressStatus: '진행상태 :',

  messageTypes: {
    text: '문자 메시지',
    friendtalk: '브랜드자유',
    alimtalk: '알림톡',
    brandtalk: '브랜드 메시지',
    friendtalkWideItemList: '브랜드자유 와이드 아이템 리스트',
    friendtalkCommerce: '브랜드자유 커머스',
    friendtalkCarouselFeed: '브랜드자유 캐러셀 피드',
    friendtalkCarouselCommerce: '브랜드자유 캐러셀 커머스',
    friendtalkPremiumVideo: '브랜드자유 프리미엄 동영상',
    brandtalkText: '브랜드메시지 텍스트',
    brandtalkImage: '브랜드메시지 이미지',
    brandtalkWideImage: '브랜드메시지 와이드 이미지',
    brandtalkWideItemList: '브랜드메시지 와이드 아이템 리스트',
    brandtalkCommerce: '브랜드메시지 커머스',
    brandtalkCarouselFeed: '브랜드메시지 캐러셀 피드',
    brandtalkCarouselCommerce: '브랜드메시지 캐러셀 커머스',
    brandtalkPremiumVideo: '브랜드메시지 프리미엄 동영상',
  },
  label: {
    all: '전체',
    notSelected: '미선택',
    departmentName: '부서명',
    findId: '아이디 찾기',
    id: '아이디',
    findPassword: '비밀번호 찾기',
    changePassword: '비밀번호 변경',
    email: '이메일',
    login: '로그인',
    journeyNameSearch: '메시지 그룹 검색',
    messageActivitySearch: 'Activity 검색',
    sendingProfile: '발신프로필 선택',
    category: '카테고리',
    strikethrough: '취소선 적용',
    addChannel: '채널 추가',
    imageName: '이미지명',
    activationStatus: '활성화 상태',
    activate: '활성화',
    deactivate: '비활성화',
    templateCode: '템플릿 코드 :',
    status: '상태 :',
    updateUser: '사용자 수정',
    addUser: '사용자 생성',
    phoneNumber: '휴대폰 번호',
    userName: '사용자 이름',
    securitySettings: '보안 설정',
    mfaSettings: 'MFA 설정',
    ipSettings: 'IP 설정',
    allowIP: '허용 IP',
    comment: '비고',
    templateInspection: '템플릿 검수',
    inquiryDetails: '문의 내용',
    selectFile: '파일 선택',
    addImage: '이미지 등록',
    imageType: '이미지 타입',
    imageList: '이미지 목록',
    type: '유형',
    size: '크기',
    ratio: '비율',
    created: '등록일',
    createRejection: '수신거부 고객 등록',
    rejectPhone: '수신거부 번호',
    customerNumber: '고객 번호',
    scheduleDownload: '다운로드 예약',
    currentPassword: '현재 비밀번호',
    newPassword: '새 비밀번호',
    confirmPassword: '새 비밀번호 확인',
    nextChange: '다음에 변경하기',
    inquiryList: '문의 내역',
    attachment: '첨부파일',
    companyName: '기업명',
    ip: 'IP',
    serviceName: '서비스명',
    ARSNumber: 'ARS번호',
    userList: '사용자 목록',
    recipientNumberSearch: '수신자 번호 검색',
    activitySearch: 'Activity 검색',
  },
  comment: {
    inquiry: [
      '송금하기 버튼',
      '템플릿을 승인받기 위해서는',
      '결제사를 확인할 수 있는 결제 페이지 캡쳐 이미지',
      '를 함께 첨부해야 합니다.',
      '앱링크 버튼 scheme_android, scheme_ios 필드에',
      'alimtalk=kakaopay://money/to/bank?',
      '형태로 scheme를 기입할 경우,',
      '송금하기 버튼을 등록할 수 있습니다.',
      '자세한 사항은',
      '카카오 가이드',
      '를 참고해 주세요.',
    ],
    inquiryDetails: [
      '문의 300자 파일',
      '첨부 파일 목록(최대 10개)',
      '- 지원 확장자 ( .png, .jpg, .jpeg, .gif, .pdf, .hwp, .doc, .docx )',
      '- 각 개별 파일의 최대 크기 5mb',
      '- 전체 업로드 가능한 파일의 최대 크기 50mb',
    ],

    scheduleDownload: `- 생성일시로부터 하루가 지난 파일은 만료되어 삭제 됩니다.
- 파일 요청시 파일을 생성하는데에 시간이 소요되며 ‘진행중’은 최대 5개까지 가능합니다.`,
    resettingPassword: `- 최초 로그인 시 설정된 비밀번호는 임시이며,

    - 비밀번호는 영문 대소문자, 숫자/특수문자를 조합한 8~100자 이내`,
    updateUser: [
      '- IP는 계정당 최대 5개까지 등록 가능합니다.',
      '- 휴대폰 번호는 한국 통신사 번호만 가능합니다.',
    ],
    addUser: [
      '- IP는 계정당 최대 5개까지 등록 가능합니다.',
      '- 비밀번호는 사용자 생성 시, 임시 비밀번호로 발급됩니다.',
      '- 휴대폰 번호는 한국 통신사 번호만 가능합니다.',
    ],
    templateInspection: [
      '- 템플릿 제출을 원하실 경우 \'검수 요청\' 버튼을 클릭해주세요.',
      '- 템플릿 관련 문의 등록을 원하실 경우 \'문의 등록\' 버튼을 클릭해주세요.',
    ],
    changePassword: [
      '개인정보보호와 안전한 사이트 이용을 위해',
      '3개월 마다 비밀번호 변경을 권장하고 있습니다.',
    ],
    passwordRule: '비밀번호는 최소 8자 이상이며, 영문 대문자, 소문자, 숫자, 특수문자를 모두 포함해야 합니다.',

    // TODO
    image: {
      select: '등록할 메시지 타입과 이미지 타입을 선택하세요.',
      messageType: '메시지 타입에 따라 규격이 달라지며, 변경 시 등록된 이미지가 초기화됩니다.',
      preview: '규격에 맞는 이미지만 업로드 가능하며, 선택 후 미리보기로 확인할 수 있습니다.',
      mms: '* MMS :',
      mmsExtension: '- 파일형식 : JPG, JPEG',
      mmsSize: '- 용량/사이즈 : 100KB 이하 / 1000x1000',
      normal: '* 브랜드자유 메시지 일반 이미지 :',
      kakaoExtension: '- 파일형식 : JPG, PNG',
      normalSize: '- 용량/사이즈 : 5MB 이하 / 800x400(2:1 비율) 권장',
      wide: '* 브랜드자유 메시지 와이드 이미지:',
      wideSize: '- 용량/사이즈 : 5MB 이하 / 800x600 (4:3비율) 권장',
      kakaoCopyright: '카카오의 로고, 상표, 서비스명, 저작물 등을 무단으로 사용 및 정보성(알림톡)/광고성(친구톡) 메시지 작성에 따른 가이드를 위반할 경우 카카오 채널 서비스에 대한 이용이 제한될 수 있습니다.',
      mainWideItemList: '* 브랜드자유 메시지 메인 와이드 아이템 리스트 이미지:',
      mainWideItemListSize: '- 용량/사이즈 : 5MB / 800x400 (2:1 비율) 권장',
      wideItemList: '* 브랜드자유 메시지 와이드 아이템 리스트 이미지:',
      wideItemListSize: '- 용량/사이즈 : 5MB / 800x800 (1:1 비율) 권장',
      carouselFeed: '* 브랜드자유 메시지 캐러셀 피드 이미지:',
      carouselFeedSize: '- 용량/사이즈 : 5MB 이하 / 800x400(2:1 비율), 800x600(4:3비율) 권장',
      carouselCommerce: '* 브랜드자유 메시지 캐러셀 커머스 이미지:',
      carouselCommerceSize: '- 용량/사이즈 : 5MB 이하 / 800x400(2:1 비율), 800x600(4:3비율) 권장',

      alimtalk: '* 알림톡 일반 이미지:',
      alimtalkSize: '- 용량/사이즈 : 500KB 이하 / 800x400(2:1 비율) 권장',
      // XXX
      // 권장 사이즈/파일형식/파일 용량 : 800×400px /JPG, PNG / 최대 500KB
      // 가로:세로 비율이 2:1 아닐 경우, 가로 500px, 세로 250px 이하일 경우 업로드 불가
      alimtalkHighlight: '* 알림톡 하이라이트 썸네일 이미지:',
      alimtalkHighlightSize: '- 용량/사이즈 : 500KB 이하 / 가로 108px 이상 (1:1 비율)',
      carouselCommerceIntro: '* 브랜드자유 캐러셀 커머스 인트로 이미지:',
      carouselCommerceIntroSize: '- 용량/사이즈 : 5MB 이하 / 800x400(2:1 비율), 800x800(1:1 비율), 800x600(4:3비율) 권장',
      commerce: '* 브랜드자유 커머스 이미지:',
      commerceSize: '- 용량/사이즈 : 500KB 이하 / 800x400(2:1 비율), 800x800(1:1 비율), 800x600(4:3비율) 권장',
      premiumVideoThumbnail: '* 브랜드자유 프리미엄 동영상 썸네일 이미지:',
      premiumVideoThumbnailSize: '- 용량/사이즈 : 500KB 이하 / 800x400(2:1 비율), 800x800(1:1 비율), 800x600(4:3비율) 권장',
    },
    brandImage: {
      normal: '* 브랜드 메시지 일반 이미지 :',
      normalSize: '- 용량/사이즈 : 5MB 이하 / 800x400(2:1 비율) 권장',
      wide: '* 브랜드 메시지 와이드 이미지:',
      wideSize: '- 용량/사이즈 : 5MB 이하 / 800x600 (4:3비율) 권장',
      mainWideItemList: '* 브랜드 메시지 메인 와이드 아이템 리스트 이미지:',
      mainWideItemListSize: '- 용량/사이즈 : 5MB / 800x400 (2:1 비율) 권장',
      wideItemList: '* 브랜드 메시지 와이드 아이템 리스트 이미지:',
      wideItemListSize: '- 용량/사이즈 : 5MB / 800x800 (1:1 비율) 권장',
      carouselFeed: '* 브랜드 메시지 캐러셀 피드 이미지:',
      carouselFeedSize: '- 용량/사이즈 : 5MB 이하 / 800x400(2:1 비율), 800x600(4:3비율) 권장',
      carouselCommerce: '* 브랜드 메시지 캐러셀 커머스 이미지:',
      carouselCommerceSize: '- 용량/사이즈 : 5MB 이하 / 800x400(2:1 비율), 800x600(4:3비율) 권장',
    },
    // image: [
    //   '- 100KB이하의 jpg, jpeg 파일만 등록 가능',
    //   '- 이미지는 .jpg 또는 .png 형식만 지원합니다.',
    //   '- 이미지 크기는 일반 이미지 500KB 이하, 와이드 이미지 5MB 이하여야 합니다.',
    //   '- 일반 이미지는 가로 길이는 최소 500px, 세로 길이는 최소 250px 이상, 와이드 이미지는 가로 길이 800px, 세로 길이 600px이어야 합니다.',
    //   '- 일반 이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
    //   '카카오의 로고, 상표, 서비스명, 저작물 등을 무단으로 사용 및 정보성(알림톡)/광고성(친구톡) 메시지 작성에 따른 가이드를 위반할 경우 카카오 채널 서비스에 대한 이용이 제한될 수 있습니다.',
    //   '- 이미지 크기는 5MB 이하여야 합니다.',
    //   '- 이미지는 가로 길이 400px, 세로 길이 400px~가로 길이 800px, 세로 길이 400px이어야 합니다.',
    //   '- 비율 및 가로 픽셀을 확인하지 않으며, 섬네일 크기에 맞추어 중앙 기준으로 크롭하여 노출됩니다.',
    //   '- 이미지는 가로 길이 500px이상, 가로:세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
    //   '- 이미지 크기는 500KB 이하여야 합니다.',
    //   '가로 : 세로 비율은 2:1여야 합니다.',
    //   '가로는 최소 500px, 세로는 최소 250px 이상이어야 합니다.',
    //   '가로 108px 이상, 가로 : 세로 비율은 1:1여야 합니다.',
    // ],
    ip: '※ IP는 계정당 최대 5개까지 등록 가능합니다.',
    alimTalkTemplate: {
      button: '템플릿 안내사항',
      title: '안내사항을 꼭 확인해 주세요.',
      content: [
        '‘검수 중’, ‘승인‘ 상태인 템플릿은 수정 및 삭제가 불가합니다. 필요 시 신규 템플릿을 등록하세요.',
        '(새로운 템플릿 추가 등록 요망)',
        '‘임시 저장’ 상태의 템플릿은 조회 화면에서 수정할 수 있습니다.',
        '‘임시 저장‘ 상태의 템플릿은 조회 화면에서 검수요청을 클릭해야 정상적으로 카카오 검수 요청이 진행됩니다.',
      ],
    },
  },
  status: {
    apply: '적용',
    notApplied: '미적용',
    registered: '등록',
    requested: '요청',
    reviewing: '진행중',
    approved: '승인',
    rejected: '반려',
    realTime: '실시간',
    contractExpiration: '계약 만료',
    lock: '잠금',
    notSent: '미발송',
    passwordError5: '비밀번호 5회 오류',
    sent: '발송',
    temporaryPassword: '임시 비밀번호 발급',
    notApproved: '미승인',
    normal: '정상',
    abnormal: '비정상',
    rejection: '거부',
    noRejection: '거부 안함',
  },
  head: {
    comment: '비고',
    phoneNumber: '휴대폰 번호',
    email: '이메일',
    userEmail: '사용자 이메일',
    id: '아이디',
    ip: '아이피',
    enabled: '활성화 여부',
    update: '수정',
    imageName: '이미지명',
    imageType: '이미지 타입',
    imageSize: '이미지 사이즈',
    imageRatio: '이미지 비율',
    imageThumbnail: '이미지 썸네일',
    image: '이미지',
    content: '내용',
    fileId: '파일 ID',
    requestPath: '요청 경로',
    requestedTime: '요청 일시',
    status: '상태',
    loginIp: '로그인 IP',
    lastLogin: '최종 로그인',
    createdAt: '등록 일시',
    urlCopy: 'URL 복사',
  },
  button: {
    createRejection: '수신거부 고객 등록',
    addUser: '사용자 생성',
    update: '수정',
    selectDelete: '선택 삭제',
    ok: '확인',
    changePassword: '비밀번호 변경하기',
    terms: '이용약관',
    privacyPolicy: '개인정보 처리방침',
    load: '불러오기',
    register: '등록하기',
    delete: '삭제',
    addImage: '이미지 추가',
    viewLarger: '크게보기',
    download: '다운로드',
    scheduledFileDownload: '예약된 파일 다운로드',
    scheduledCsvFileDownload: '예약된 CSV 파일 다운로드',
    scheduleDownloadOfSearchResults: '검색 결과 다운로드 예약',
    add: '추가',
    resetPassword: '비밀번호 초기화',
    registerInquiry: '문의 등록',
    inspectionRequest: '검수 요청',
    regist: '등록',
    addButton: '추가하기',
    viewLargerImage: '이미지 크게보기',
    refresh: '새로고침',
    cancel: '취소',
    applicationExample: '적용예시 확인하기',
    copy: '복사',
  },
  placeholder: {
    file: '선택된 파일 없음',
    search: '검색어를 입력하세요.',
    password: '비밀번호를 입력해주세요.',
    confirmPassword: '비밀번호 확인을 입력해주세요.',
    inquiryDetails: '검수 담당자에게 문의할 내용을 입력해주세요. \n요청, 승인 상태의 템플릿은 문의할 수 없습니다.',
  },
  tooltip: {
    securityTemplate: [
      '보안 템플릿 여부',
      'OTP 등 보안 메시지일 경우 설정',
      '발신 당시의 메인 디바이스를 제외한 모든 디바이스에 메시지 텍스트를 표시하지 않음',
      '템플릿의 보안 상태가 카카오 가이드에 맞지 않는 경우 검수 과정에서 자동으로 보안 상태가 변경될 수 있습니다.',
    ],
    // image: [
    //   '이미지형 메시지는 아래 3가지 유형으로 사용 가능합니다.',
    //   '- 로고형',
    //   '- 텍스트 혼합형',
    //   '- 아이콘형',
    //   '<로고형>',
    //   '- 해당 채널의 가로형 로고를 활용해 메시지의 주목도를 높이고 브랜딩을 강화할 수 있는 유형',
    //   '- 이미지 배경: #F9F9F9만 사용 가능',
    //   '- 이미지 배치: 센터 가이드라인 내 로고 배치',
    //   '<텍스트 혼합형>',
    //   '- 메시지의 주요 내용을 텍스트로 표현, 내용을 보조하는 아이콘이나 오브젝트 이미지를 활용하는 유형',
    //   '- 이미지 배치: 좌상단에 주요 내용 텍스트, 우하단에 아이콘 또는 오브젝트 삽입',
    //   '- 텍스트 기준: 최대 2줄/20자 노출을 지향',
    //   '- 아이콘 크기는 최소 230x230, 최대 400x320은 넘지 않아야 합니다.',
    //   '- 텍스트 영역은 가로 540px 세로 240px이며, 좌측 상단, 좌측 정렬 고정입니다.',
    //   '- 이미지 배경색은 #F9F9F9만 가능합니다.',
    //   '<아이콘형>',
    //   '- 메시지 내용의 상태를 아이콘으로 표현하고 간략한 텍스트로 보조하는 유형 - 이미지 배경: #F9F9F9만 사용 가능',
    //   '- 이미지 배치: 센터 가이드라인 내 아이콘 및 텍스트 배치',
    //   '- 텍스트 기준: 최대 1줄/최소 2자~최대 9자 이하의 텍스트 표시',
    //   '자세한 사항은 알림톡 이미지 가이드를 참고해주세요.',
    // ],
    itemHighlight: [
      '아이템 하이라이트 등록 시, 이미지는 필수값이 아니지만 등록하려면 타이틀과 설명을 반드시 입력해야 합니다.',
      '이미지를 추가할 경우, 타이틀과 설명의 최대 길이가 각각 21자, 13자로 제한됩니다.',
      '타이틀과 설명에는 변수를 사용할 수 있습니다. 변수는 #{변수} 형태로 띄어쓰기 없이 입력합니다.',
    ],
    itemList: [
      '아이템 리스트의 항목은 최소 2개, 최대 10개로 제한됩니다.',
      '아이템 내용에는 변수를 사용할 수 있습니다. 변수는 #{변수} 형태로 띄어쓰기 없이 입력합니다.',
      '아이템리스트 사용 시, 템플릿 내용과 부가정보를 합한 총 문자 수는 최대 700자로 제한됩니다.',
    ],
    content: [
      '한/영 구분 없이 #{변수} 및 URL 포함 1,000자 까지 입력 가능합니다.',
      '변수는 #{변수} 형태로 띄어쓰기 없이 입력해야 합니다.',
      '부가정보 사용 시, 템플릿 내용과 부가정보를 합한 총 문자 수는 최대 1,000자로 제한됩니다.',
      '아이템리스트 사용 시, 템플릿 내용과 부가정보를 합한 총 문자 수는 최대 700자로 제한됩니다.',
    ],
    additionalInformation: [
      '부가정보는 최대 500자까지 입력할 수 있으며, URL 포함이 가능합니다. (#{변수} 사용 불가)',
      '부가정보 사용 시, 템플릿 내용과 부가정보를 합한 총 문자 수는 최대 1,000자로 제한됩니다.',
      '',
      '부가정보형에 광고성 문구가 들어갈 경우 :',
      '- 광고 메시지는 URL 포함이 불가능하며, 페이지 이동이 필요할 경우 WL(웹링크) 버튼 타입을 사용해야 합니다.',
      '- ‘아래 버튼을 누르시면 이벤트(또는 광고) 페이지로 이동합니다.’를 필수로 안내해야 하고, 필수 안내 멘트 포함해서 500자로 제한됩니다.',
    ],
    // TODO
    addChannelMessage: [
      '안내 멘트는 최대 80자로 변수 사용과 url 포함이 불가능합니다. (본문과 합쳐 총 1,000자를 넘을 수 없음, 부가정보형과 동시 사용 가능)',
    ],
    button: [
      '버튼은 최대 5개까지 추가 가능합니다.',
      '버튼 링크에만 #{변수}를 사용할 수 있습니다.',
      '웹 링크는 [http:// , https://]를 반드시 포함해야 하며, 500자까지 입력할 수 있습니다.',
      '(예 : https://#{home}/#{id} -> https://www.home.com/12345)',
      '- 배송 조회: 메시지 내용에서 택배사와 송장번호를 파싱해 카카오 검색 배송 조회 페이지로 이동하는 [배송 조회하기] 버튼 링크를 자동으로 생성합니다.',
      '- 웹 링크: 버튼을 클릭하면 인앱 브라우저에서 웹 페이지가 실행됩니다.',
      '- 앱 링크: 버튼을 클릭하면 앱 커스텀 스킴이 실행됩니다.',
    ],
    buttonName: '변수 입력 불가',
    buttonLink: '변수 입력 가능',
    meesageGroup: `<b>메시지 그룹명 안내</b>
    <b>- Marketing Cloud :</b> Journey 이름을 입력하세요.
    <b>- Sales Cloud :</b> Object 이름, Campaign 이름, 또는 Flow 이름 중 하나를 입력하세요.

    <b>메시지 ID 안내</b>
    메시지 ID는 아래 요소들을 조합해 생성되며, 일부 정보만 입력해도 검색할 수 있습니다.

    <b>- Marketing Cloud:</b>
      JourneyName & JourneyVersion & ActivityName & ActivityId
    <b>- Sales Cloud - Object:</b>
      ObjectName & RecordLabel & RecordId
    <b>- Sales Cloud - Campaign:</b>
      Campaign & CampaignRecordLabel & CampaignRecordId & SettingId
    <b>- Sales Cloud - Flow:</b>
      Flow & FlowRecordLabel & FlowId & FlowVersion & ElementId & SourceRecordId

    <b>예시:</b> WelcomeJourney & v1 & SendMessage & 1234-abc
      → WelcomeJourney 또는 SendMessage & 1234처럼 일부만 입력해도 검색 가능합니다.
    `,
    imageUrlCopy: '이미지 URL이 복사되었습니다.',
    imageUrlCopyFail: '브라우저 보안 정책으로 인해 iframe 화면에서는 복사가 지원되지 않습니다. 링크를 직접 선택해 복사해 주세요.',
    messageGroupUpdate: '메시지 상태는 10분마다 업데이트 됩니다.',
  },

  alert: {
    notification: '알림',
    expired: {
      title: '인증 정보가 만료되었습니다.',
      content: '로그인 페이지로 이동합니다.',
    },
    needLogin: {
      title: '로그인이 필요한 서비스입니다.',
      content: '로그인 페이지로 이동합니다.',
    },
    findId: {
      content: '아이디가 이메일로 발송 완료됐습니다. 작성하신 이메일 확인 후 이상 없으면 정상 수신 가능합니다.',
    },
    resetPassword: {
      title: '비밀번호 초기화 완료',
      content: `임시비밀번호가 발급되었습니다.
        (SMS or E-Mail)을 확인해주시고 로그인 해주세요.
        *최초 로그인 시, 임시비밀번호를 필수로 변경해야 합니다.`,
    },
    success: {
      content: '등록완료',
    },
    deleteSuccess: {
      content: '삭제완료',
    },
    userSecurity: {
      title: '알림',
      content: '보안 설정은 필수 입니다.',
    },
    resetPasswordSuccess: {
      title: '비밀번호 초기화 완료',
      content: `임시비밀번호가 발급되었습니다.
        (SMS or E-Mail)을 확인해주시고 로그인 해주세요.
        *최초 로그인 시, 임시비밀번호를 필수로 변경해야 합니다.`,
    },
    addIp: {
      title: '알림',
      content: 'IP는 계정당 최대 5개까지 등록 가능합니다.',
    },
    requestSuccess: {
      content: '검수요청 완료',
    },
    addUser: `사용자 생성이 성공적으로 완료되었습니다.
    이메일 주소로 임시 비밀번호가 발급되었습니다.'
    `,
    completed: '완료',
    applicationExample: {
      title: '기업명/서비스명 적용예시',
      imageAlt: '문자 적용 예시',
      content: '광고성 문자메시지의 첫 줄에 표시되는 발신자명입니다.',
    },
    updateSuccess: {
      content: '수정완료',
    },
  },
  hint: {
    phoneNumber: '※ 한국 통신사 번호만 입력 가능합니다.',
  },
  confirm: {
    leave: {
      title: '사이트에서 나가시겠습니까?',
      content: '변경사항이 저장되지 않을 수 있습니다.',
    },
  },
  couponType: {
    numberDiscount: 'OO원 할인 쿠폰',
    percentDiscount: 'OO% 할인 쿠폰',
    deliveryDiscount: '배송비 할인 쿠폰',
    freeCoupon: 'OO 무료 쿠폰',
    upCoupon: 'OO UP 쿠폰',
  },
  preview: {
    title: '미리보기',
    fallback: '대체발송',
  },
};
